var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.parts),function(part,i){return _c('UptraceQueryChip',{key:i,staticClass:"mr-2 mb-1",attrs:{"query":part}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }